import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { Button, CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router';

const navigationButtonBase = css`
  height: 36px;
  border-radius: 5px;
  text-transform: none;
`;

const textBase = css`
  font-family: 'Lato';
  font-size: 14px;
  letter-spacing: normal;
`;

const WhiteButton = styled(Button)`
  &&& {
    ${navigationButtonBase}
    width: ${(props) => props.width || '100px'};
    border: solid 1px #dfe3e9;

    .MuiButton-label {
      ${textBase}
      color: #5c5d5d;
    }
  }
`;

const BlackButton = styled(Button)`
  &&& {
    ${navigationButtonBase}
    width: ${(props) => props.width || '200px'};
    background-color: ${(props) => props.disabled ? 'rgb(153,154,154)' : '#1b1c1d'};

    .MuiButton-label {
      ${textBase}
      font-weight: bold;
      color: #ffffff;
    }
  }
`;

export function BackButton(props) {
  const { label = 'Back', onClick, width } = props;

  const history = useHistory();

  const handleBackClick = useCallback(() => {
    if (!onClick) {
      history.goBack();
    } else {
      onClick();
    }
  }, [history])

  return (
    <WhiteButton width={width} onClick={handleBackClick}>
      {label}
    </WhiteButton>
  );
}

export function ContinueButton(props) {
  const {
    label = 'Continue',
    onClick = () => {},
    isDisabled,
    width,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleContinueClick = useCallback(async () => {
    try {
      setIsLoading(true);
      await onClick();
    } catch (err) {
      console.error('Error in ContinueButton.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [onClick, setIsLoading])

  return (
    <BlackButton
      type="submit"
      onClick={handleContinueClick}
      disabled={isDisabled || isLoading}
      width={width}
    >
      {isLoading ? <CircularProgress size={20} /> : label}
    </BlackButton>
  );
}
